/**
 * Toggles the PDP free-shipping ribbon from the selected variant price.
 */
(function () {
  var FreeShippingRibbon = class extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.getAttribute('data-threshold-cents'), 10) || 0;
      this._currentVariantPrice = parseInt(this.getAttribute('data-variant-price'), 10) || 0;

      this.syncVisibility();

      var formId = this.getAttribute('data-product-form-id');
      this._variantForm =
        (formId && document.getElementById(formId)) ||
        document.querySelector('.shopify-section--main-product form[is="product-form"], .shopify-section--featured-product form[is="product-form"]');

      if (this._variantForm) {
        this._onVariantChange = this.handleVariantChange.bind(this);
        this._variantForm.addEventListener('variant:change', this._onVariantChange);
      }
    }

    disconnectedCallback() {
      if (this._onVariantChange && this._variantForm) {
        this._variantForm.removeEventListener('variant:change', this._onVariantChange);
      }
    }

    handleVariantChange(event) {
      var variant = event.detail && event.detail.variant;

      if (!variant) {
        return;
      }

      this._currentVariantPrice = variant.price;
      this.setAttribute('data-variant-price', variant.price);
      this.syncVisibility();
    }

    syncVisibility() {
      if (this.threshold <= 0) {
        this.hidden = true;
        return;
      }

      this.hidden = this._currentVariantPrice < this.threshold;
    }
  };

  if (!window.customElements.get('free-shipping-ribbon')) {
    window.customElements.define('free-shipping-ribbon', FreeShippingRibbon);
  }
})();
